import { useState, useCallback } from 'react';
import { message } from 'antd';
import {
  pw9324Api,
  QueryParams,
  QueryResult,
  LeaveTypeInfo,
  AnnualLeaveSummaryRow,
} from '../../../services/pw9324Api';

export interface UsePW9324QueryResult {
  loading: boolean;
  queried: boolean;
  noData: boolean;
  leaveTypes: LeaveTypeInfo[];
  data: AnnualLeaveSummaryRow[];
  count: number;
  runQuery: (params: QueryParams) => Promise<void>;
  reset: () => void;
}

export function usePW9324Query(): UsePW9324QueryResult {
  const [loading, setLoading] = useState(false);
  const [queried, setQueried] = useState(false);
  const [noData, setNoData] = useState(false);
  const [leaveTypes, setLeaveTypes] = useState<LeaveTypeInfo[]>([]);
  const [data, setData] = useState<AnnualLeaveSummaryRow[]>([]);
  const [count, setCount] = useState(0);

  const runQuery = useCallback(async (params: QueryParams) => {
    setLoading(true);
    setQueried(false);
    setNoData(false);
    try {
      const resp: QueryResult = await pw9324Api.query(params);
      setLeaveTypes(resp.leave_types || []);
      if (resp.data && resp.data.length > 0) {
        setData(resp.data);
        setCount(resp.count);
        setNoData(false);
      } else {
        setData([]);
        setCount(0);
        setNoData(true);
        message.info(resp.message || '查無此資料!');
      }
      setQueried(true);
    } catch {
      message.error('查詢失敗，請稍後再試');
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setQueried(false);
    setNoData(false);
    setLeaveTypes([]);
    setData([]);
    setCount(0);
  }, []);

  return { loading, queried, noData, leaveTypes, data, count, runQuery, reset };
}
